import { useMutation } from "@tanstack/react-query";
import { AxiosRequestConfig } from "axios";
import axios from "../../../../services/department-viags/config.service";
import { BaseResponse } from "../../../chats/types";

interface MovePublicFolderSchema {
  key: string;
  newParentKey: string;
  newPosition: number;
}

const BASE_PATH = "/edoc";

const publicFolderApi = {
  move: async (body: MovePublicFolderSchema, config?: AxiosRequestConfig) => {
    await axios.post<BaseResponse<unknown>>(`${BASE_PATH}/move-public-folder`, body, config);
  },
};

const useMovePublicFolder = () => {
  return useMutation({
    mutationFn: (body: MovePublicFolderSchema) => publicFolderApi.move(body),
  });
};

export default useMovePublicFolder;
